/**
 *  @author: Maximilian Gertz
 *  @email: mgertz@nanocosmos.net
 *  @organization: Nanocosmos GmbH
 *  @version: (introduced in analytics-front) 2.26.0
 */

// React Imports
import React from 'react';
import { PropTypes } from 'prop-types';

// Redux Imports

// External Libraries

// Custom Imports
import {
   BadgeListItem,
   BottomMargin,
   CustomCard,
   CustomCardBody,
   FontStyle,
   FormattedLink,
   SimpleFlexRow,
   SimpleHorizontalSeparator,
   SymbolContainer,
   TextColumn,
   TextRow,
} from '../../../../../../styledComponents/styledComponents';
import { ALERT_MAPPER } from './AlertDetailsMapper.js';

function AlertDetailsPanel({ selectedAlert }) {
   const codes = selectedAlert.codes;
   const ALERT_CODE = codes[codes.length - 1];
   return (
      <CustomCard style={{ marginLeft: '0px', marginRight: '0px', marginBottom: '15px' }}>
         <CustomCardBody>
            <BottomMargin pxSize={15}>
               <div style={{ fontWeight: 'bold' }}>
                  About: <BadgeListItem $fontSizePx={14}>{selectedAlert.label}</BadgeListItem>
               </div>
               {Array.isArray(selectedAlert.messages) ? selectedAlert.messages.join(' ') : selectedAlert.messages}
            </BottomMargin>
            <BottomMargin pxSize={15}>
               <div style={{ fontWeight: 'bold' }}>
                  Category: <BadgeListItem $fontSizePx={14}>{ALERT_MAPPER[ALERT_CODE].category}</BadgeListItem>
               </div>
               {ALERT_MAPPER[ALERT_CODE].categoryDescription}
            </BottomMargin>
            <BottomMargin pxSize={0}>
               <div style={{ fontWeight: 'bold' }}>Recommended Action:</div>
               {ALERT_MAPPER[ALERT_CODE].recommendation}
            </BottomMargin>
            <SimpleHorizontalSeparator spacePx={15} border={'1px dotted  rgb(180,180,180)'} />
            <SimpleFlexRow style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
               <SymbolContainer>
                  <i className='bi bi-info-square'></i>
               </SymbolContainer>
               <TextColumn>
                  <TextRow>
                     <FormattedLink
                        href='https://docs.nanocosmos.de/docs/analytics/alerting#alert-definitions'
                        target='_blank'
                        rel='noopener noreferrer'
                     >
                        Click here to find out when an{' '}
                        <FontStyle $fontWeight={750} $textDecoration={'underline'}>
                           alert
                        </FontStyle>{' '}
                        is detected and how they are defined.
                     </FormattedLink>
                  </TextRow>
               </TextColumn>
            </SimpleFlexRow>
         </CustomCardBody>
      </CustomCard>
   );
}

AlertDetailsPanel.propTypes = {
   selectedAlert: PropTypes.object,
};

export default AlertDetailsPanel;
